import { now } from "@zyzgroup/core-common";

export class Clock {
  autoStart: boolean;
  startTime: number;
  oldTime: number;
  elapsedTime: number;
  running: boolean;

  constructor(autoStart = true) {
    this.autoStart = autoStart;
    this.startTime = 0;
    this.oldTime = 0;
    this.elapsedTime = 0;
    this.running = false;
  }

  start() {
    this.startTime = now();
    this.oldTime = this.startTime;
    this.elapsedTime = 0;
    this.running = true;
  }

  stop() {
    this.getElapsedTime();
    this.running = false;
    this.autoStart = false;
  }

  // 毫秒
  getElapsedTime() {
    this.getDelta();
    return this.elapsedTime;
  }

  // 毫秒
  getDelta() {
    let diff = 0;
    if (this.autoStart && !this.running) {
      this.start();
      return 0;
    }
    if (this.running) {
      const newTime = now();
      diff = newTime - this.oldTime;
      this.oldTime = newTime;
      this.elapsedTime += diff;
    }
    return diff;
  }
}

export default Clock;
